<script lang="ts">
  import { onMount } from 'svelte';
  import SettingsLayout from '../../components/SettingsLayout.svelte';
  import { showAlert } from '../../lib/ui-alert';
  import { fetchFunnels, createFunnel, type FunnelListItem } from '../../lib/funnels-api';
  import { fmtInt } from '../../lib/format';
  import FunnelEventsEditor from '../../components/FunnelEventsEditor.svelte';

  let items = $state<FunnelListItem[]>([]);
  let loading = $state(true);
  let eventsSlug = $state<string | null>(null);

  async function load() {
    items = await fetchFunnels();
    loading = false;
  }
  onMount(load);

  let showCreate = $state(false);
  let cName = $state('');
  let cSlug = $state('');
  function slugify(s: string): string {
    return s.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'funnel';
  }
  async function onCreate(e: SubmitEvent) {
    e.preventDefault();
    const slug = (cSlug.trim() || slugify(cName));
    if (!cName.trim()) return;
    try {
      // Створюємо з одним entry-стейджем (без правил — додаються у редакторі).
      await createFunnel({
        slug,
        name: cName.trim(),
        stages: [
          { slug: 'entry', name: 'Вхід', ordinal: 0, isEntry: true, matchers: [] },
        ],
        customEvents: [],
      });
      showCreate = false;
      cName = '';
      cSlug = '';
      await load();
      eventsSlug = slug; // одразу відкриваємо редактор стейджів/подій
    } catch (e2) {
      showAlert((e2 as Error).message);
    }
  }
</script>

{#if eventsSlug}
  <FunnelEventsEditor slug={eventsSlug} onClose={() => { eventsSlug = null; void load(); }} />
{/if}

<SettingsLayout active="funnels">
  <div class="mx-auto max-w-[1200px]">
    <header class="mb-5 flex items-end justify-between gap-3 flex-wrap">
      <div>
        <h1 class="text-xl font-semibold leading-tight">Налашт. воронок</h1>
        <p class="mt-1 text-[12px] text-[var(--color-text-muted)]">
          «Редагувати ✎» → стейджі (порядок = pipeline) + події-правила, що рухають сутності між ними.
        </p>
      </div>
      <button onclick={() => (showCreate = true)} class="rounded-md bg-[var(--color-pu)] px-3 py-1.5 text-xs font-semibold text-white">+ Нова воронка</button>
    </header>

    {#if showCreate}
      <form onsubmit={onCreate} class="rounded-xl border border-[var(--color-border-3)] bg-white p-4 mb-4 grid grid-cols-[1fr_1fr_auto_auto] gap-2 items-end">
        <label class="block"><div class="text-[10px] font-semibold uppercase text-[var(--color-text-muted-2)] mb-1">Назва</div>
          <input bind:value={cName} required class="w-full rounded-md border border-[var(--color-border-3)] px-2.5 py-1.5 text-xs" placeholder="Мінік «Набряки»" /></label>
        <label class="block"><div class="text-[10px] font-semibold uppercase text-[var(--color-text-muted-2)] mb-1">Slug (опц.)</div>
          <input bind:value={cSlug} class="w-full rounded-md border border-[var(--color-border-3)] px-2.5 py-1.5 text-xs font-mono" placeholder="minik-nabryaky" /></label>
        <button type="submit" class="rounded-md bg-[var(--color-pu)] px-3 py-1.5 text-xs font-semibold text-white">Створити</button>
        <button type="button" onclick={() => (showCreate = false)} class="rounded-md border border-[var(--color-border-3)] px-3 py-1.5 text-xs">×</button>
      </form>
    {/if}

    {#if loading}
      <div class="py-20 text-center text-sm text-[var(--color-text-muted)]">Завантаження…</div>
    {:else}
      <div class="grid grid-cols-2 gap-3.5">
        {#each items as f (f.slug)}
          <div class="rounded-xl border border-[var(--color-border-3)] bg-white p-4">
            <div class="flex items-start justify-between mb-2">
              <div>
                <div class="text-[13px] font-bold">{f.name}</div>
                <div class="text-[10px] text-[var(--color-text-muted)] mt-0.5">slug: <code>{f.slug}</code></div>
              </div>
              <span class="rounded-full px-2 py-0.5 text-[10px] font-bold {f.isActive ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700'}">
                {f.isActive ? 'active' : 'inactive'}
              </span>
            </div>
            <div class="flex items-center justify-between">
              <div class="text-[10.5px] text-[var(--color-text-muted)]">{fmtInt(f.stages.length)} стадій</div>
              <button onclick={() => (eventsSlug = f.slug)} class="rounded-md border border-[var(--color-border-3)] px-2.5 py-1 text-[11px] font-semibold text-[var(--color-pu-3)] hover:bg-[var(--color-bg-3)]">Редагувати ✎</button>
            </div>
            <div class="mt-3 flex flex-col gap-1">
              {#each f.stages as s (s.slug)}
                <div class="flex items-center justify-between rounded bg-[var(--color-bg-3)] px-2.5 py-1 text-[11px]">
                  <span><strong class="text-[var(--color-pu-3)] mr-1.5">{s.ordinal}.</strong> {s.name}</span>
                  <span class="text-[10px] text-[var(--color-text-muted)]">{s.matchersCount} правил</span>
                </div>
              {/each}
            </div>
          </div>
        {/each}
      </div>
    {/if}
  </div>
</SettingsLayout>
